'use client';
import React from 'react';
import { ArrowUpDown } from 'lucide-react';
import { useWorksheetStore } from './worksheetStore';

const SORT_OPTIONS = [
  { value: 'newest', label: 'Newest First' },
  { value: 'most-downloaded', label: 'Most Downloaded' },
  { value: 'title-az', label: 'Title A–Z' },
] as const;

export default function WorksheetSortControl() {
  const { sortBy, setSortBy } = useWorksheetStore();

  return (
    <div className="flex items-center gap-2 flex-shrink-0">
      <ArrowUpDown size={14} className="text-muted-foreground" />
      <select
        value={sortBy}
        onChange={(e) => setSortBy(e.target.value as typeof sortBy)}
        className="text-sm border border-border rounded-lg px-3 py-1.5 bg-card text-foreground focus:outline-none focus:ring-2 focus:ring-ring cursor-pointer"
        aria-label="Sort worksheets"
      >
        {SORT_OPTIONS.map((opt) => (
          <option key={`sort-${opt.value}`} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}